import React from 'react';
import { createRoot } from 'react-dom/client';

import STKFE from '@/stk-fe';
import { STKProviderConfig } from '@/context/context';

const container = document.getElementById('root');
const root = createRoot(container!);

const loginUrl = `${import.meta.env.VITE_FZ_TOOLING_API_URL}/login`;
const apiUrl = import.meta.env.VITE_FZ_TOOLING_API_URL;
const disableAuth = import.meta.env.REACT_APP_DISABLE_AUTH_LOCAL === 'true';
const config: STKProviderConfig = {
  loginUrl,
  apiUrl,
  disableAuth,
};

root.render(
  <React.StrictMode>
    <STKFE config={config} />
  </React.StrictMode>,
);
